const createDataInit = () => ({
    target_no: '',
    application_date: '',
    start_date: '',
    end_date: '',
    start_time: '',
    end_time: '',
    time_in: '',
    time_out: '',
    reasonClass: '',
    reason: '',
    content: '',
    ShinseiDetail: '',
    money: '',
    detailClass: '',
    detail: '',
    target_month: '',
    file_list: createEmptyFileList()
});

export default {
    namespaced: true,
    state: {
        data: {
            ...createDataInit()
        },
        options: {
            reasonClasses: [],
            detailClasses: []
        }
    },
    mutations: {
        setData(state, payload) {
            state.data = {
                ...state.data,
                ...(payload || {})
            };
        },
        setOptions(state, payload) {
            state.options = {
                ...state.options,
                ...(payload || {})
            };
        },
        resetData(state) {
            state.data = {
                ...createDataInit()
            };
        }
    }
};

function createEmptyFileItem() {
    return {
        name: '',
        path: '',
        old_path: '',
        file: null
    };
}

function createEmptyFileList() {
    return [createEmptyFileItem()];
}
